export class CategoryNotFoundError extends Error {
    constructor(message?: string) {
        super(message);

        // Set the prototype explicitly to maintain the instance of CategoryNotFoundError.
        Object.setPrototypeOf(this, CategoryNotFoundError.prototype);
    }
}

export class CategoryValidationError extends Error {
    constructor(message?: string) {
        super(message);

        // Set the prototype explicitly to maintain the instance of CategoryValidationError.
        Object.setPrototypeOf(this, CategoryValidationError.prototype);
    }
}

export class SubcategoryNotFoundError extends Error {
    constructor(message?: string) {
        super(message);

        // Set the prototype explicitly to maintain the instance of SubcategoryNotFoundError.
        Object.setPrototypeOf(this, SubcategoryNotFoundError.prototype);
    }
}

export class SubcategoryValidationError extends Error {
    constructor(message?: string) {
        super(message);

        // Set the prototype explicitly to maintain the instance of SubcategoryValidationError.
        Object.setPrototypeOf(this, SubcategoryValidationError.prototype);
    }
}
